export default __webpack_public_path__ + "static/media/ic-txn.77ac10c0.svg";